function SummaryTile({ label, value, helper, tone = 'blue', onClick }) {
  const toneClasses = {
    blue: 'border-blue-200 bg-blue-50 text-blue-700',
    emerald: 'border-emerald-200 bg-emerald-50 text-emerald-700',
    amber: 'border-amber-200 bg-amber-50 text-amber-700',
  };

  const className = `rounded-lg border border-gray-200 bg-white p-[clamp(0.5rem,1.4vw,1rem)] text-left shadow-sm transition ${onClick ? 'hover:-translate-y-0.5 hover:border-gray-300 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500' : ''}`;
  const content = (
    <div className="flex items-center gap-[clamp(0.5rem,1.5vw,1rem)]">
      <div className={`inline-flex h-[clamp(2.5rem,5vw,4rem)] w-[clamp(2.5rem,5vw,4rem)] shrink-0 items-center justify-center rounded-md border text-[clamp(1rem,2vw,1.5rem)] font-bold ${toneClasses[tone]}`}>
        {value}
      </div>
      <div className="min-w-0">
        <h2 className="break-words text-[clamp(0.875rem,1.8vw,1.25rem)] font-semibold leading-tight text-gray-950">{label}</h2>
        {helper && <p className="dashboard-summary-helper mt-1 break-words text-[clamp(0.75rem,1.3vw,1rem)] leading-tight text-gray-600">{helper}</p>}
      </div>
    </div>
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={className}>
        {content}
      </button>
    );
  }

  return (
    <article className={className}>
      {content}
    </article>
  );
}

export default SummaryTile;
